import { AppSelector } from 'bootstrap.store';

export const selectIsPrimaryConnection: AppSelector<boolean> = (state) =>
  state.websocket.meta.isPrimaryConnection;
